import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsIssueLayoutRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-issue-layout',
	path: '/plugins/servlet/project-config/:projectKey/issuelayout',
};
